import EditMediaDialog from './EditMediaDialog'
import type { EditMediaDialogProps } from './EditMediaDialog'

export type { EditMediaDialogProps }
export default EditMediaDialog
